import type {
  IConstsMailSubscription,
  IModelMailSubscription,
  ISettingsMailSubscription,
} from '@/shared/types/mailSubscription';

export const getModel = ({
  mailSubscription,
}: MailSubscriptionRootState): Nullable<IModelMailSubscription> => mailSubscription.model;
export const getSettings = ({
  mailSubscription,
}: MailSubscriptionRootState): Nullable<ISettingsMailSubscription> => mailSubscription.settings;
export const getConstants = ({
  mailSubscription,
}: MailSubscriptionRootState): Nullable<IConstsMailSubscription> => mailSubscription.constants;
